import * as actionTypes from "~/store/action_types";
import { mergeEntities } from "~/utils/reduxUtils";

const notes = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ADD_COMMENT_LOADING: {
      if (!action.parentId || action.parentType !== "Note" || !state[action.parentId.toString()]) {
        return state;
      }
      const selectedNote = state[action.parentId.toString()];
      return {
        ...state,
        [action.parentId.toString()]: {
          ...selectedNote,
          comments_count: selectedNote.comments_count ? selectedNote.comments_count + 1 : 1,
        },
      };
    }
    case actionTypes.MOVE_COMMENT_TO_TRASH_SUCCESS: {
      if (!action.parentId || action.parentType !== "Note" || !state[action.parentId.toString()]) {
        return state;
      }
      const selectedNote = state[action.parentId.toString()];
      return {
        ...state,
        [action.parentId.toString()]: {
          ...selectedNote,
          comments_count: selectedNote.comments_count ? selectedNote.comments_count - 1 : 0,
        },
      };
    }
    case actionTypes.DUPLICATE_NOTE_SUCCESS:
    case actionTypes.FETCH_NOTEBOOK_NOTES_SUCCESS:
    case actionTypes.FETCH_NOTES_SUCCESS:
    case actionTypes.FETCH_NOTE_SUCCESS:
    case actionTypes.PREFETCH_NOTE_SUCCESS:
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
    case actionTypes.ADD_NOTE_SUCCESS:
    case actionTypes.REVERT_NOTE_TO_ORIGINAL_SUCCESS:
    case actionTypes.REVERT_NOTE_TO_MODIFICATION_SUCCESS:
    case actionTypes.FETCH_ATTACHMENTS_SUCCESS:
    case actionTypes.FETCH_FILES_AND_ATTACHMENTS_SUCCESS:
    case actionTypes.MOVE_NOTE_TO_PROJECT_SUCCESS:
    case actionTypes.ADD_NOTE_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {} } = response;
      return mergeEntities(state, entities.notes);
    }
    case actionTypes.EDIT_NOTE_SUCCESS: {
      const { response } = action;
      const noteId = response.result.single;
      const editedNote = response.entities.notes[noteId];
      return {
        ...state,
        [noteId]: editedNote,
      };
    }
    case actionTypes.RESTORE_NOTE_FROM_TRASH_SUCCESS:
    case actionTypes.MOVE_NOTE_TO_TRASH_SUCCESS: {
      if (!action.objectType || action.objectType !== `Note` || !action.id || !state[action.id]) {
        return state;
      }
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single } = result;
      const { notes = {} } = entities;

      const note = notes[single];

      if (note) {
        return {
          ...state,
          [single]: note,
        };
      }

      return state;
    }

    case actionTypes.MOVE_NOTE_TO_TRASH_FROM_EVENT_STREAM:
    case actionTypes.RESTORE_NOTE_FROM_TRASH_FROM_EVENT_STREAM:
    case actionTypes.UPDATE_NOTE_FROM_EVENT_STREAM:
    case actionTypes.NOTE_MOVED_TO_PROJECT_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: noteId } = response;
      const { notes = {} } = entities;

      const data = notes[`${noteId}`];

      if (data) {
        return { ...state, [noteId]: { ...state[noteId], ...data } };
      }

      return state;
    }
    case actionTypes.CLEAR_NOTES: {
      return {};
    }
    case actionTypes.FETCH_CALENDAR_ASSIGMENTS_SUCCESS:
    case actionTypes.PROJECT_TEMPLATE_APPLY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { notes } = entities;

      if (!notes) {
        return state;
      }
      return mergeEntities(state, notes);
    }
    default:
      return state;
  }
};

export default notes;
